import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/less_than_black.svg'
import _imports_1 from '@/assets/images/asana_logo.png'
import _imports_2 from '@/assets/images/pluss_icon.svg'
import _imports_3 from '@/assets/images/upload_fill.svg'


const _hoisted_1 = { class: "time-entry-info-view-main-block" }
const _hoisted_2 = { class: "name-block" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "entry-info-names" }
const _hoisted_5 = { class: "h5" }
const _hoisted_6 = { class: "entry-info-project-block" }
const _hoisted_7 = { class: "entry-info-project-name small-text" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "create-entry-info-button-image",
  src: _imports_2
}, null, -1)
const _hoisted_9 = { class: "create-entry-info-button-text medium-text" }
const _hoisted_10 = { class: "time-entry-info-top-block" }
const _hoisted_11 = { class: "my-activities small-text-grey" }
const _hoisted_12 = {
  key: 0,
  class: "time-spent-block"
}
const _hoisted_13 = { class: "time-spent-text small-text-grey" }
const _hoisted_14 = { class: "time-spent-time small-text-grey" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "time-entry-info-divider" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "no-info default-text"
}
const _hoisted_17 = {
  key: 1,
  class: "no-info-image"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_entry_delete_popup = _resolveComponent("time-entry-delete-popup")!
  const _component_upload_popup = _resolveComponent("upload-popup")!
  const _component_snackbar = _resolveComponent("snackbar")!
  const _component_progress_bar = _resolveComponent("progress-bar")!
  const _component_task_item_header = _resolveComponent("task-item-header")!
  const _component_time_entry_info_item = _resolveComponent("time-entry-info-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showDeleteWarning)
      ? (_openBlock(), _createBlock(_component_time_entry_delete_popup, {
          key: 0,
          warningText: _ctx.timeEntryWarningText,
          confirmDeleteText: _ctx.timeEntryConfirmDeleteText,
          cancelDeleteText: _ctx.timeEntryCancelDeleteText,
          onDeleteObjectEmit: _ctx.deleteSelectedEntry,
          onCancelDelete: _ctx.cancelDeletionOfEntry
        }, null, 8, ["warningText", "confirmDeleteText", "cancelDeleteText", "onDeleteObjectEmit", "onCancelDelete"]))
      : _createCommentVNode("", true),
    (_ctx.showUpload)
      ? (_openBlock(), _createBlock(_component_upload_popup, {
          key: 1,
          onCloseUpload: _ctx.closeUplodad
        }, null, 8, ["onCloseUpload"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass([['snackbar-div', _ctx.snackbarCustomClass], "info-view-snackbar"])
      }, [
        _createVNode(_component_snackbar, {
          buttonActionText: _ctx.buttonActionText,
          text: _ctx.snackbarMessage,
          show: _ctx.showSnackbar,
          onCloseSnackBar: _ctx.closeSnackBar
        }, null, 8, ["buttonActionText", "text", "show", "onCloseSnackBar"])
      ], 2),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "back-button small-text-grey",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leavePage()))
        }, [
          _hoisted_3,
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("component-entry-info-view.back")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.task.task_name), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["task-color", _ctx.task?.color])
            }, null, 2),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.project.name), 1)
          ])
        ]),
        (_ctx.showAsanaLogo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "info-asana-logo",
              src: _imports_1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToAsana()))
            }))
          : _createCommentVNode("", true),
        (_ctx.showCreateEntryButton)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["create-entry-info-button", { 'margin-left-auto': !_ctx.showAsanaLogo }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createNewEntry()))
            }, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("component-task-list.new-entry")), 1)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.showUploadButton)
          ? (_openBlock(), _createElementBlock("img", {
              key: 2,
              class: "upload-buton",
              src: _imports_3,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showUploadPopup()))
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_progress_bar, {
        class: "time-entry-info-view-progress-bar-wrapper",
        ref: "progressBar",
        onProgressBarBlock: _ctx.addMargin
      }, null, 8, ["onProgressBarBlock"]),
      _createElementVNode("div", {
        class: _normalizeClass(["due-date small-text", {
          'added-due-date-margin': _ctx.addMargin,
        }])
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("component-entry-info-view.due")) + " " + _toDisplayString(_ctx.dueDate), 1)
      ], 2),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("component-entry-info-view.my-activities")), 1),
        (!_ctx.hideNoEntries)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("component-entry-info-view.time-spent")), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.displayedCombinedHours), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_15,
      _createElementVNode("div", {
        class: "time-entry-info-block",
        onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
        ref: "infiniteScroll"
      }, [
        (_ctx.hideNoEntries)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t("component-entry-info-view.no-activities")), 1))
          : _createCommentVNode("", true),
        (_ctx.hideNoEntries)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDate, (mapInfo, indexTwo) => {
          return (_openBlock(), _createElementBlock("div", { key: indexTwo }, [
            _createVNode(_component_task_item_header, {
              taskDate: indexTwo,
              infoDate: ""
            }, null, 8, ["taskDate"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mapInfo, (entry, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "time-entry-info-item",
                key: index
              }, [
                _createVNode(_component_time_entry_info_item, {
                  taskInfo: entry,
                  onDuplicationEmit: ($event: any) => (_ctx.duplicateEntry(entry)),
                  onDelitionEmit: ($event: any) => (_ctx.deleteEntry(entry)),
                  onEditionEmit: ($event: any) => (_ctx.editEntry(entry))
                }, null, 8, ["taskInfo", "onDuplicationEmit", "onDelitionEmit", "onEditionEmit"])
              ]))
            }), 128))
          ]))
        }), 128))
      ], 544)
    ])
  ]))
}